var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-grid"},[_c('navigation'),_vm._v(" "),_c('home'),_vm._v(" "),_c('feature'),_vm._v(" "),_c('favourite'),_vm._v(" "),_c('contact'),_vm._v(" "),_c('pageFooter')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6bae8aaa","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/viewLanding.vue
// module id = 52
// module chunks = 0